<template>
	<div class="">
		<base-page-heading
			title="Model2d"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="model2dShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<Model2dTable @routeModel2d="routeModel2d" />
		</div>
	</div>
</template>
